/*
 * views/splash.js
 * Splash View
 */

define('app/views/splashView',[
    'lib/event',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/serviceTypeList',
    'hbs!app/views/templates/footer',
    'bootstrap'
], function (Event, commonViewHelper, navbarTpl, serviceTypeListTpl, footerTpl) {
    var splashView = {
        app:app,
        event:$.extend({}, Event),
        module:"splash"
    };

    splashView.event.listen('initTemplate', splashView, function (e) {
        $('#nav').html(navbarTpl({
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            Customization:app.customization,
            Localization:app.localization,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#footer').html(footerTpl({
            Customization:app.customization,
            Localization:app.localization
        }))
        if (!!location.hash.replace(/^[#/]+/, '')) {
            $('#progressIndicator').modal('show');
        }
    });

    splashView.event.listen('requestServiceTypeSelection', splashView, function (e) {
        console.log('requestServiceTypeSelection');


        //If theres club in cart, then redirect all modoules except club to the summary page to complete that message first
        var services = JSON.parse(JSON.stringify(app.data.serviceTypes))|| []
        // $.when(
        //     app.models.systemModel.getData('folioBookings', {}))
        //     .always(function (r_fb) {
        //       if(r_fb.WebFolioItem && r_fb.WebFolioItem[0].Category == "Club"){
        //           console.log("777",)
        //         $.each(services,function(){
        //             if(this.id != "membership"){
        //                 this.href = "summary"
        //             }
        //         })
        //       }
        //     })
        if(app.data.clubBookingInCart){
        $.each(services,function(){
            if(this.id != "membership"){
                this.href = "summary"
            }
        })
        }
        $('#main').html(serviceTypeListTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:services,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#nav').html(navbarTpl({
            services:services,
            languages:app.data.languageNames,
            Customization:app.customization,
            Localization:app.localization,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#footer').html(footerTpl({
            Customization:app.customization,
            Localization:app.localization
        }))
    
        commonViewHelper.updateNavBar(null,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
   
    });

    splashView.event.listen('displayRemainingUpTime', splashView, function (e, minutes) {
        $('#uptimewarning').remove();
        $('#warnings').append('<div id="uptimewarning" class="alert alert-warning"><strong>' + app.localization.general.maintenance.maintenanceMessage + ' ' + minutes + ' ' + app.localization.general.maintenance.maintenanceMessageTimeUnit + '</strong></div>');
    });

    splashView.event.listen('clearRemainingUpTime', splashView, function (e) {
        $('#uptimewarning').remove();
    });

    splashView.event.listen('folioTimeoutWarning', splashView, function (e, minutes) {
        $('#foliowarning').remove();
        $('#warnings').append('<div id="foliowarning" class="alert alert-warning"><strong>' + app.localization.general.maintenance.folioTimeOutWarning + ' ' + minutes + ' ' + app.localization.general.maintenance.maintenanceMessageTimeUnit + '</strong><button class="foliowarningClose">x</button></div> ');
        if (app.customization.login.alternativeNavbarLogin && !app.data.userLoggedIn) {
            $('#foliowarning').css('margin-top', '93px');
            $('div#main').css('top', '45px');
        } else {
            $('#foliowarning').css('margin-top', '53px');
            $("div#main").css("top", "5px");
        }
        $('.foliowarningClose').on('click',function () {
            $('#foliowarning').remove();
        })
      commonViewHelper.handleSessionTimeOut();
     
    });

    splashView.event.listen('clearTimeoutWarning', splashView, function (e) {
        $('#foliowarning').remove();
    });

    splashView.event.listen('folioTimedOut', splashView, function (e) {
        $('body').append('<div class="modal hide" id="folioTimedOut">\
            <div class="modal-header">\
            <h3>'+app.localization.general.err.timeoutTitle+'</h3>\
        </div>\
            <div class="modal-body">\
                <p>'+app.localization.general.err.timeoutText+'</p>\
                <p>'+app.localization.general.err.timeoutContinue+'</p>\
            </div>\
            <div class="modal-footer">\
                <a id="restart" href="#/" class="btn btn-primary">'+app.localization.general.err.startOver+'</a>\
            </div>\
        </div>');

        commonViewHelper.prepFolioTimedOut();
    });

    splashView.event.listen('folioCheckedOut', splashView, function (e) {
        if (app.data.folioCheckedOutFired) return;
        app.data.folioCheckedOutFired = true;
        $('body').append('<div class="modal hide folioCheckedOut" id="folioTimedOut">\
            <div class="modal-header">\
            <h3>'+app.localization.general.err.checkedoutTitle+'</h3>\
        </div>\
            <div class="modal-body">\
                <p>'+app.localization.general.err.checkedoutText+'</p>\
' + ( app.data.receipt
            ? app.localization.paymentProcessing.receiptHeader + app.data.receipt + app.localization.paymentProcessing.receiptFooter
            : ""
    ) + '                <p>'+app.localization.general.err.checkedoutContinue+'</p>\
            </div>\
            <div class="modal-footer">\
            ' + ( (app.localization.general.paymentCompleteMainSiteButton && app.localization.general.paymentCompleteMainSiteLink)
                ? '    <a id="mainsite" href="' + app.localization.general.paymentCompleteMainSiteLink + '" class="pull-left btn btn-primary">'+app.localization.general.paymentCompleteMainSiteButton+'</a>\
            '   : '' )
            +
            '    <a id="restart" href="#/" class="btn btn-primary">'+(app.localization.general.paymentCompleteStartOverButton||app.localization.general.err.startOver)+'</a>\
            </div>\
        </div>\
' + ( app.data.receipt
            ? '<div class="printReceipt">' + app.localization.paymentProcessing.receiptHeader + app.data.receipt + app.localization.paymentProcessing.receiptFooter + '</div>\
<style type="text/css" media="print">\n\
#main, #footer, .modal, .modal-backdrop, .printReceipt .btn { display:none !important }\n\
.printReceipt { display:inline-block }\n\
</style>'
            : ""
    ) + '');

        commonViewHelper.prepFolioTimedOut();
    });

    splashView.event.listen('displaySystemOffline', splashView, function (e) {
        $('#nav').html('<div class="offset4 span4">\
            <h2 id="loadMessage">'+app.localization.general.err.serverOffline+'</h2>\
        </div>');
        $('#main').html('');
        $('#warnings').html('');
    });

    splashView.event.listen('requestBookingTypeSelection', splashView, function (e) {
        console.log('request BookingTypeSelection');
        $('#main').empty().append('<div id=vue-app-mode></div>')
        require(['modeSelector/starter'], function (starter) {
            starter({view:'splashView',event:'requestServiceTypeSelection'});
        })
    }); // abhi here

    return window.app.views.splashView = splashView;
});

